import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import IconFilter from 'components/icons/iconFilter2';
import { colorGray, colorWhite } from 'styles/layout/colors';
import MobileOnly from 'components/consumer/MobileOnly';
const MobileProductFiltersButton = t0 => {
  const $ = _c(17);
  const {
    activeFilterCount,
    onClick
  } = t0;
  const hasActiveFilters = activeFilterCount > 0;
  const t1 = !hasActiveFilters;
  let t2;
  if ($[0] !== hasActiveFilters || $[1] !== t1) {
    t2 = classNames("md:hidden text-sm font-bold items-center rounded-sm flex justify-center mr-[6px] p-3 border-[1px] max-h-12", {
      "bg-brand border-brand text-white": hasActiveFilters,
      "bg-white border-gray-light3 text-gray": t1
    });
    $[0] = hasActiveFilters;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = hasActiveFilters ? colorWhite : colorGray;
  let t4;
  if ($[3] !== t3) {
    t4 = <IconFilter className="mr-[6px]" color={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !hasActiveFilters;
  let t6;
  if ($[5] !== hasActiveFilters || $[6] !== t5) {
    t6 = classNames("h-full", {
      "text-gray": t5,
      "text-white": hasActiveFilters
    });
    $[5] = hasActiveFilters;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span>Filters</span>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = activeFilterCount > 0 && ` (${activeFilterCount})`;
  let t9;
  if ($[9] !== t6 || $[10] !== t8) {
    t9 = <span className={t6}>{t7}{t8}</span>;
    $[9] = t6;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== onClick || $[13] !== t2 || $[14] !== t4 || $[15] !== t9) {
    t10 = <MobileOnly><button type="button" className={t2} onClick={onClick}>{t4}{t9}</button></MobileOnly>;
    $[12] = onClick;
    $[13] = t2;
    $[14] = t4;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export default MobileProductFiltersButton;